import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, ModalBody } from "reactstrap";
import { WhiteButton } from "styledComponents/buttons";

import arrowLeft from "../../assets/img/onboardingImg/left-arrow.svg";
import tickBlack from "../../assets/img/onboardingImg/tick-black.svg";
import tickBlue from "../../assets/img/onboardingImg/tick-blue.svg";
import tickGreen from "../../assets/img/onboardingImg/tick-green.svg";
import tickPurple from "../../assets/img/onboardingImg/tick-purple.svg";
import { getOrganizationPlans } from "../../custom_modules/Organization/OrganizationActions";
import { getOrganizationSubscription } from "../../custom_modules/Subscription/subscriptionActions";
import { YearlySaveBadge } from "../../custom_modules/Subscription/subscriptionStyles";
import { ToggleSection, ToggleText } from "../../styledComponents/billing";
import { CommonFlex, CommonGrid } from "../../styledComponents/common";
import PlanToggleSwitch from "./PlanToggleSwitch";
import { getPlanFeaturesShort } from "./planFeatures";
import {
  ArrowLeft,
  ComparePlansLink,
  EverythingInPrev,
  FeatureText,
  FeatureTickIcon,
  HeaderTitle,
  MoneyBackTag,
  NotificationText,
  PlanDescription,
  PlanFeaturesContainer,
  PlanName,
  PlanNameAndTagContainer,
  PlanNameTag,
  PlanPrice,
  PlanPriceContainer,
  PlanPriceText,
  PlanSelectButton,
  PlusAddonDiv,
  PricingCardContainer,
  PricingPlanContainer,
  PricingPlanHeader,
  SinglePlanFeature,
  SinglePricingCard,
  TopSectionContainer,
  TypeText,
  TypeTogglerContainer,
} from "./pricingPlanStyles";

const planPriceMonthly = {
  standard: 15,
  elite: 20,
};
const planPriceYearly = {
  standard: 9,
  elite: 12,
};

const PlanTypeToggler = props => {
  return (
    <CommonGrid columns="auto" justifyContent="center" padding="30px 0 20px 0">
      <ToggleSection>
        <ToggleText
          active={props.planType === "yearly"}
          onClick={() => props.togglePlanType("yearly")}
        >
          <YearlySaveBadge isActive={props.planType === "yearly"}>
            Save 40%
          </YearlySaveBadge>
          Yearly
        </ToggleText>
        <ToggleText
          active={props.planType === "monthly"}
          onClick={() => props.togglePlanType("monthly")}
        >
          Monthly
        </ToggleText>
      </ToggleSection>
    </CommonGrid>
  );
};

const PricingPlan = ({
  isOpen,
  toggle,
  popupText,
  popupTitle,
  backRoute,
  history,
  onlyElite,
}) => {
  const dispatch = useDispatch();
  const subscriptionPlans = useSelector(state => state.organization.allPlans);
  const currentSubscription = useSelector(
    state => state.subscription.currentSubscription,
  );
  const selectedOrganization = useSelector(
    state => state.organization.selectedOrganization,
  );
  const [planInterval, setPlanInterval] = useState("yearly");
  const isOperation = selectedOrganization?.type === "operation";
  const orgType = selectedOrganization?.type || "operation";
  const planFeaturesShort = getPlanFeaturesShort(orgType);
  

  useEffect(() => {
    if (selectedOrganization) {
      dispatch(getOrganizationPlans());
      dispatch(
        getOrganizationSubscription({
          organization_id: selectedOrganization.id,
        }),
      );
    }
  }, [dispatch, selectedOrganization]);

  const togglePlanInterval = () => {
    if (planInterval === "monthly") {
      setPlanInterval("yearly");
    } else {
      setPlanInterval("monthly");
    }
  };

  const handleBack = () => {
    toggle();
    // Always navigate to dashboard when modal closes
    history.push("/user/dashboard");
  };

  const handleModalToggle = () => {
    // When modal is being closed (isOpen is true), use handleBack
    // This ensures ESC key and other close actions also navigate properly
    if (isOpen) {
      handleBack();
    } else {
      toggle();
    }
  };

  const handlePlanSelection = plan => {
    const yearlyPlan = subscriptionPlans.find(
      p => p.name === plan && p.interval === "yearly",
    );
    const monthlyPlan = subscriptionPlans.find(
      p => p.name === plan && p.interval === "monthly",
    );
    
    history.push({
      pathname: "/user/checkout",
      state: {
        interval: planInterval,
        yearly: {
          id: yearlyPlan.id,
          name: yearlyPlan.name,
          paddleId: yearlyPlan.paddle_id,
          amount: yearlyPlan.amount,
          interval: "yearly",
          currentUsers: currentSubscription?.member_count,
        },
        monthly: {
          id: monthlyPlan.id,
          name: monthlyPlan.name,
          paddleId: monthlyPlan.paddle_id,
          amount: monthlyPlan.amount,
          interval: "monthly",
          currentUsers: currentSubscription?.member_count,
        },
        currentPlan: {
          id: currentSubscription?.plan?.id,
          name: currentSubscription?.plan?.name,
          interval: currentSubscription?.plan?.interval,
        },
      },
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleModalToggle}
      style={{ maxWidth: `760px`, paddingTop: `0` }}
      backdrop="static"
      backdropClassName="pricing-plan-modal-backdrop"
    >
      <ModalBody style={{ padding: `30px` }}>
        <PricingPlanContainer>
          <CommonFlex justifyContent="space-between" margin="0 0 7px 0">
            <NotificationText>
              {popupText ? popupText : "you've reached the limit"}
            </NotificationText>
            <MoneyBackTag>
              {" "}
              <span>✅</span> 100% money back guarantee
            </MoneyBackTag>
          </CommonFlex>
          <HeaderTitle>
            {popupTitle ? popupTitle : "Upgrade your plan"}
          </HeaderTitle>
          <PlanTypeToggler
            planType={planInterval}
            togglePlanType={togglePlanInterval}
          />
          <PricingCardContainer onlyElite={onlyElite}>
            {!onlyElite && (
              <SinglePricingCard plan="standard">
                <TopSectionContainer>
                  <PlanNameAndTagContainer>
                    <PlanName plan="standard">STANDARD</PlanName>
                    <PlanNameTag plan="standard">
                      Geofenced Attendance
                    </PlanNameTag>
                  </PlanNameAndTagContainer>
                  <PlanPriceContainer>
                    <PlanPrice>
                      $
                      {planInterval === "yearly"
                        ? planPriceYearly.standard
                        : planPriceMonthly.standard}
                    </PlanPrice>
                    <PlanPriceText>per user per month</PlanPriceText>
                  </PlanPriceContainer>
                  <PlanSelectButton
                    plan="standard"
                    onClick={() => handlePlanSelection("Standard")}
                  >
                    Upgrade to Standard
                  </PlanSelectButton>
                </TopSectionContainer>
                <PlanFeaturesContainer>
                  {planFeaturesShort.standard.map((item, index) => (
                    <SinglePlanFeature key={index}>
                      <FeatureTickIcon src={tickBlue} alt="" />
                      <FeatureText>{item}</FeatureText>
                    </SinglePlanFeature>
                  ))}
                </PlanFeaturesContainer>
              </SinglePricingCard>
            )}
            <SinglePricingCard plan="elite">
              <TopSectionContainer>
                <PlanNameAndTagContainer>
                  <PlanName plan="elite">ELITE</PlanName>
                  <PlanNameTag plan="elite">Field, Remote & Hybrid</PlanNameTag>
                </PlanNameAndTagContainer>
                <PlanPriceContainer>
                  <PlanPrice>
                    $
                    {planInterval === "yearly"
                      ? planPriceYearly.elite
                      : planPriceMonthly.elite}
                  </PlanPrice>
                  <PlanPriceText>per user per month</PlanPriceText>
                </PlanPriceContainer>
                <PlanSelectButton
                  plan="elite"
                  onClick={() => handlePlanSelection("Elite")}
                >
                  Upgrade to Elite
                </PlanSelectButton>
              </TopSectionContainer>
              <EverythingInPrev plan="elite">
                <ArrowLeft src={arrowLeft} alt="" />
                <FeatureText style={{ marginLeft: "8px" }}>
                  Everything in Standard
                </FeatureText>
              </EverythingInPrev>
              <PlusAddonDiv>Plus Add On:</PlusAddonDiv>
              <PlanFeaturesContainer>
                {planFeaturesShort.elite.map((item, index) => (
                  <SinglePlanFeature key={index}>
                    <FeatureTickIcon plan="elite" src={tickBlue} alt="" />
                    <FeatureText>{item}</FeatureText>
                  </SinglePlanFeature>
                ))}
              </PlanFeaturesContainer>
            </SinglePricingCard>
          </PricingCardContainer>
          <CommonFlex justifyContent="space-between" margin="20px 0 0 0">
            <WhiteButton onClick={() => handleBack()}>Back</WhiteButton>
            <ComparePlansLink
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.fieldservicely.com/pricing"
            >
              Compare all Plans
            </ComparePlansLink>
            <div />
          </CommonFlex>
        </PricingPlanContainer>
      </ModalBody>
    </Modal>
  );
};

export default PricingPlan;
